import styles from './Heading.module.css'
import classnames from 'classnames'

export interface HeadingProps {
  id?: string
  tagSize?: 1 | 2 | 3 | 4 | 5 | 6
  fontClass?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'sp' | 'display' | 'xl-display'
  isFlatSize?: boolean
  noMarginBottom?: boolean
  color?: 'black' | 'white' | 'paragraph-text' | 'brand-secondary' | 'brand-tertiary' | 'line-light'
  isItalic?: boolean
  children: React.ReactNode
}

export const Heading = ({
  id,
  tagSize = 1,
  fontClass = 'h1',
  isFlatSize = false,
  noMarginBottom = false,
  color = 'black',
  isItalic = false,
  children,
}: HeadingProps) => {
  const HeadingTag = `h${tagSize}` as keyof JSX.IntrinsicElements

  const classes = classnames(styles.Heading, styles[`Heading--is-${color}`], {
    [styles[`Heading--${fontClass}`]]: !isFlatSize,
    [styles[`Heading--flat-${fontClass}`]]: isFlatSize,
    [styles['Heading--is-italic']]: isItalic,
    [styles['Heading--no-margin-bottom']]: noMarginBottom,
  })

  return <HeadingTag id={id} className={classes}>{children}</HeadingTag>
}

